@if (!withoutFormat) {
  @if (auszugItem?.printPDFPossible && auszugItem?.printRTFPossible) {
    <div class="btn-group btn-group-sm" role="group">
      <button
        (click)="selectSettings('PDF')"
        [disabled]="showSpinner(_indexNumber, 'PDF') || isPrintingInProgress()"
        [ngbTooltip]="tooltip"
        class="btn btn-white buttonGroup"
        container="body"
        type="button">
        <span class="sr-only">{{ auszugItem.srTitle | translate }}</span>
        PDF
        @if (showSpinner(_indexNumber, "PDF")) {
          <span class="spinner-border spinner-border-sm text-dark mr-1"></span>
        }
      </button>
      <button
        (click)="selectSettings('RTF')"
        [disabled]="showSpinner(_indexNumber, 'RTF') || isPrintingInProgress()"
        [ngbTooltip]="tooltip"
        class="btn btn-white buttonGroup"
        container="body"
        type="button">
        <span class="sr-only">{{ auszugItem.srTitle | translate }}</span>
        RTF
        @if (showSpinner(_indexNumber, "RTF")) {
          <span class="spinner-border spinner-border-sm text-dark mr-1"></span>
        }
      </button>
      <ng-template [ngTemplateOutlet]="content"></ng-template>
    </div>
  } @else {
    <div class="btn-group btn-group-sm">
      @if (auszugItem?.printPDFPossible) {
        <button (click)="selectSettings('PDF')" [ngbTooltip]="tooltip" class="btn btn-white buttonCol" container="body" type="button">
          <span class="sr-only">{{ auszugItem.srTitle | translate }}</span>
          PDF
        </button>
      }
      @if (auszugItem?.printRTFPossible) {
        <button (click)="selectSettings('RTF')" [ngbTooltip]="tooltip" class="btn btn-white buttonCol" container="body" type="button">
          <span class="sr-only">{{ auszugItem.srTitle | translate }}</span>
          RTF
        </button>
      }
      <ng-template [ngTemplateOutlet]="content"></ng-template>
    </div>
  }
}

@if (withoutFormat) {
  <button
    (click)="selectSettings(undefined)"
    [disabled]="!(auszugItem?.printPDFPossible || auszugItem?.printRTFPossible)"
    [ngbTooltip]="auszugItem?.printPDFPossible || auszugItem?.printRTFPossible ? tooltip : ('not.authorized' | translate)"
    class="btn btn-link"
    type="button">
    <span aria-hidden="true" class="far fa-file-alt fa-1x me-1"></span>
    <span>{{ auszugItem.srTitle | translate }}</span>
  </button>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #tooltip>
  {{ auszugItem.tooltip }}
</ng-template>
